import {
  ApiGetRequest,
  ApiPostRequest,
  ApiDeleteRequest,
  ApiPutRequest,
} from '../../../api';
import { showNotif } from '../../notification';

export const state = {
  data: {
    title: 'Master Rekening Perkiraan',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/fin',
      },
      {
        text: 'Rekening Perkiraan',
        href: '/adm/fin/master/rekening-perkiraan',
        active: true,
      },
    ],
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: '',
    sortDesc: false,
    fields: [
      {
        key: 'code_acc',
        label: 'Kode Akun',
        sortable: true,
        thStyle: {
          width: '130px',
        },
      },
      {
        key: 'classification',
        label: 'Klasifikasi',
        sortable: true,
      },
      {
        key: 'acc_name',
        label: 'Nama Akun',
        sortable: true,
      },
      {
        key: 'acc_alias',
        label: 'Alias',
        sortable: true,
      },
      {
        key: 'currency',
        label: 'Mata Uang',
        sortable: true,
      },
      {
        key: 'is_active',
        label: 'Aktif',
        sortable: true,
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    fields_choose_account: [
      {
        key: 'code_acc',
        label: 'Akun',
        sortable: true,
      },
      {
        key: 'classification',
        label: 'Klasifikasi',
        sortable: true,
      },
      {
        key: 'acc_name',
        label: 'Nama Akun',
        sortable: true,
      },
      {
        key: 'acc_alias',
        label: 'Alias',
        sortable: true,
      },
    ],
    detail: false,
    form: {
      id_parent: '',
      code_acc: '',
      acc_alias: '',
      acc_name: '',
      is_cash_bank: 0,
      is_active: 1,
      id_currency: '',
    },
    acc_level_three: [],
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
};

export const mutations = {
  changeAccount(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async searchAccount(context, params = null) {
    let result = await ApiGetRequest(`fin/account/level-four`, params);
    return !result.error ? result.data.object : [];
  },

  async getAccountLevelThree({ commit }) {
    commit('changeAccount', {
      loading: true,
    });

    let result = await ApiGetRequest(`fin/account/level-three`);
    commit('changeAccount', {
      acc_level_three: !result.error ? result.data.object : [],
      loading: false,
    });

    return !result.error ? result.data.object : [];
  },

  async getListAccountLevelFour({ commit, state }) {
    commit('changeAccount', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
    };

    let result = await ApiGetRequest(`fin/account/level-four`, params);
    commit('changeAccount', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? result.data.object : [];
  },

  async getListAccount({ commit, state }) {
    commit('changeAccount', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
    };

    let result = await ApiGetRequest(`fin/account`, params);
    commit('changeAccount', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? result.data.object : [];
  },

  async getDetailAccount({ commit, state }, payload = null) {
    commit('changeAccount', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`fin/account/${payload.id}`);
    commit('changeAccount', {
      form: {
        ...data.form,
        ...result.data.object,
      },
      loading: false,
    });

    return !result.error ? result.data.object : false;
  },

  async createAccount({ commit, state, dispatch }) {
    commit('changeAccount', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest(`fin/account`, data.form);
    commit('changeAccount', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updateAccount({ commit, state, dispatch }, payload = null) {
    commit('changeAccount', {
      loading: true,
    });

    let result = await ApiPutRequest(
      `fin/account/${payload.id}`,
      state.data.form
    );

    commit('changeAccount', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async deleteAccount({ commit, dispatch }, payload = null) {
    commit('changeAccount', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`fin/account/${payload.id}`);
    commit('changeAccount', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },
};
